/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "059fe624ba5dca32bc0916c212cb96184b5edaf6";
